import type { WatchQueryFetchPolicy } from '@apollo/client';

import { useDraftJobLazyQuery } from 'src/graphql/generated';

export const useGetDraftLazyQuery = (
  draftId: string,
  fetchPolicy?: WatchQueryFetchPolicy,
) =>
  useDraftJobLazyQuery({
    variables: { id: draftId },
    fetchPolicy: fetchPolicy ?? 'network-only',
  });
